export const transIt = {
    myLocal: {
        columns: 'Columns',
        hide_filter: 'Pre-Filters', //'Hide Filter',
        show_filter: 'Pre-Filters', //'Show Filter',
    },
    dbFields: {}
}
